import { render, staticRenderFns } from "./NewWorkshopContainer.vue?vue&type=template&id=5c33e128"
import script from "./NewWorkshopContainer.vue?vue&type=script&lang=js"
export * from "./NewWorkshopContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports